import { TagFilled } from '@ant-design/icons'
import { Tooltip } from 'antd'

import Text from '~/core/Text'
import getColor from '~/lib/getColor'

type PreferredPricingIconTooltipPropsType = {
    discount: number | null
    marginTop?: string
}

const PreferredPricingIconTooltip = ({
    discount,
    marginTop,
}: PreferredPricingIconTooltipPropsType) => {
    if (!discount) {
        return null
    }
    return (
        <Tooltip
            title={<Text>Preferred Pricing of {discount}% off applied</Text>}
            placement="bottom"
        >
            <TagFilled
                style={{
                    color: getColor('primary6'),
                    fontWeight: 500,
                    fontSize: '14px',
                    marginTop: `${marginTop ? marginTop : '2px'}`,
                    marginRight: '4px',
                }}
            />
        </Tooltip>
    )
}

export default PreferredPricingIconTooltip
